import axios from 'axios';

import { IErrorData } from 'error-handler/functions/sendError';
import { isObject } from 'error-handler/helper/utils';

import config from 'error-handler/config';

const admin = async (errorData: IErrorData, logs: any[]) => {
  const { error, errorInfo, metaInfo, funcName } = errorData;

  const html = document.querySelector('html') as HTMLElement;
  const sendError: any = {
    error: isObject(error) ? error.message : error,
    errorInfo: errorInfo
      ? isObject(errorInfo)
        ? Object.entries(errorInfo)
            .map(([key, value]) => `${key}: ${value}`)
            .join('\n')
        : errorInfo
      : metaInfo?.errorInfo,
    function: funcName ?? metaInfo?.Function,
    component: metaInfo?.Component,
    author: metaInfo?.Author,
    href: location.href,
    type: 'front',
  };
  if (logs.length > 0) {
    sendError.logs = logs;
    sendError.size = { width: html.offsetWidth, height: html.offsetHeight, vHeight: html.clientHeight };
  }
  config.host !== 'loc' && (await axios.post(`${config.LOGS_SERVER_URL}/api/errors`, sendError));
};

export default admin;
